export default function parseInteger(value: string | null | undefined): number | undefined {
  const valueWithoutSpaces = value?.replaceAll(" ", "");
  if (valueWithoutSpaces && /^[-+]?[1-9]\d*$|^0$/.test(valueWithoutSpaces)) {
    return parseInt(valueWithoutSpaces, 10);
  }
  return undefined;
}
